import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=1c0fe34d&"
import script from "./TemplateEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports